import {AxiosResponse} from 'axios';

import axios from '@/core/tools/axios';

export default class MediaService {
  static getMedias(id: string): Promise<AxiosResponse> {
    return axios.get(`/medias/${id}`);
  }
}
